import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import * as benchlingUtil from 'BenchlingUtil';
import * as FileConstants from 'folder-items/FileConstants';
import BenchLink from 'link-preview/BenchLink';
import TagValueViewer from 'metadata/TagValueViewer';
import * as RichObjectTable from 'ui-library/RichObjectTable';
import {TableCollapserContext} from 'ui-library/tables/TableCollapserContext';
import {readableTime} from 'util/DateUtil';
import {STAGE_RUN_STATUS, STATUS_FRIENDLY_NAME} from 'workflows/constants/StageRunConstants';
import {SAMPLE_COLUMN_LABEL} from 'workflows/WorkflowConstants';

function withoutCustomTags(tags: Array<FileConstants.Tag>): Array<FileConstants.SchemaTag> {
  // TODO: suport custom tags
  return tags.filter((tag) => FileConstants.isSchemaTag(tag));
}

interface ResponseSampleTableProps {
  header: JSX.Element;
  records: Array<{
    id: string;
    createdAt: string;
    status: STAGE_RUN_STATUS;
    tags: Array<FileConstants.Tag>;
    url: string;
  }>;
}

export default function ResponseSampleTable(props: ResponseSampleTableProps): JSX.Element {
  assert(props.records.length > 0, 'Expected records');

  const sortedRecords = _.sortBy(props.records, 'id');
  const headerCells = [
    SAMPLE_COLUMN_LABEL,
    'Status',
    'Created At',
    ...withoutCustomTags(props.records[0].tags).map((tag) => tag.tagSchemaField.displayName),
  ];

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values -- Disabling for now, but worth fixing
    <TableCollapserContext.Provider value={{isTableInitiallyCollapsed: false}}>
      <RichObjectTable.Table
        leftHeader={props.header}
        headerCells={headerCells}
        dataTestAttrs={{component: 'ResponseSampleTable', element: 'root'}}
      >
        {sortedRecords.map((record, i) => (
          <RichObjectTable.Row key={i}>
            <RichObjectTable.Cell>
              <BenchLink href={benchlingUtil.pathToURL(record.url)}>{record.id}</BenchLink>
            </RichObjectTable.Cell>
            <RichObjectTable.Cell>{STATUS_FRIENDLY_NAME[record.status]}</RichObjectTable.Cell>
            <RichObjectTable.Cell>{readableTime(record.createdAt)}</RichObjectTable.Cell>
            {withoutCustomTags(record.tags).map((tag) => (
              <RichObjectTable.Cell key={tag.name}>
                <TagValueViewer tag={tag} />
              </RichObjectTable.Cell>
            ))}
          </RichObjectTable.Row>
        ))}
      </RichObjectTable.Table>
    </TableCollapserContext.Provider>
  );
}
